<template>
  <v-dialog v-model="dialog" fullscreen scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn depressed color="primary" small v-bind="attrs" v-on="on">
        Compara
      </v-btn>
    </template>
    <v-card>
      <v-toolbar max-height="64px" flat color="primary">
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text">
          Comparador - {{ planificacioTitle }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="canEdit"
          @click.stop="copyObjectius"
          color="white"
          depressed
          small
          :disabled="selectedforPending.length === 0"
        >
          <v-icon class="rotate-icon">double_arrow</v-icon>
          Copiar a pendents {{ selectedforPending.length }} elements
        </v-btn>
      </v-toolbar>

      <v-container class="fill-height">
        <v-card-text class="pa-0 fill-height">
          <v-row align="stretch" class="fill-height">
            <v-col cols="6" class="py-0 fill-height">
              <v-card flat outlined class="fill-height comparador--column">
                <v-toolbar
                  color="primary"
                  flat
                  class="comparador--column-toolbar"
                >
                  <v-text-field
                    v-model="filterActivitat"
                    label="Cerca activitat"
                    clear-icon="highlight_off"
                    clearable
                    class="ma-1"
                    outlined
                    dense
                    hide-details
                    dark
                  />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="mt-1 mx-2 pa-2"
                        :color="searchBoth ? 'white' : 'primary'"
                        :dark="!searchBoth"
                        depressed
                        style="min-width: unset;"
                        @click.stop="searchBoth = !searchBoth"
                      >
                        <v-icon v-if="!searchBoth">compare_arrows</v-icon>
                        <v-icon v-else>swap_horiz</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="!searchBoth"
                      >Cerca a les dues planificacions</span
                    >
                    <span v-else>
                      Cerca només a <b>{{ planificacioTitle }}</b>
                    </span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="mt-1 pa-2"
                        :color="openAllBoard ? 'white' : 'primary'"
                        :dark="!openAllBoard"
                        style="min-width: unset;"
                        @click.stop="openAllBoard = !openAllBoard"
                        depressed
                      >
                        <v-icon v-if="openAllBoard">unfold_less</v-icon>
                        <v-icon v-else>unfold_more</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="openAllBoard">Tancar Sessions</span>
                    <span v-else>Obrir Sessions</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text class="comparador--column-body">
                  <v-treeview
                    :items="board"
                    :open="openAllBoardArr"
                    item-text="title"
                    :search="filterActivitat"
                    open-on-click
                    :key="boardKey"
                    class="pb-6"
                  >
                    <template v-slot:label="{ item }">
                      <span
                        class="d-flex justify-space-between"
                        :class="{
                          'green--text':
                            item.meta && isUsed(mapIdComp, item.meta.id),
                        }"
                      >
                        {{ item.title }}
                        <v-chip v-if="item.children.length > 0" small>
                          {{ item.children.length }}
                        </v-chip>
                        <v-tooltip
                          v-if="item.meta && isUsed(mapIdComp, item.meta.id)"
                          bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              @click.stop="searchItem(item.title)"
                              class="warning--text"
                              small
                            >
                              find_replace
                            </v-icon>
                          </template>
                          <span>Cerca ràpida</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-treeview>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" class="py-0 fill-height">
              <v-card
                color="grey lighten-4"
                flat
                class="fill-height comparador--column"
              >
                <v-toolbar
                  flat
                  color="grey lighten-3"
                  class="comparador--column-toolbar"
                >
                  <v-combobox
                    :items="planificacions"
                    label="Escull una planificació"
                    @change="updateComp"
                    dense
                    hide-details
                    autofocus
                    outlined
                  />

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="m1-1 ml-2 pa-2"
                        :color="openAllComp ? 'primary' : 'grey lighten-3'"
                        style="min-width: unset;"
                        @click.stop="openAllComp = !openAllComp"
                        depressed
                      >
                        <v-icon v-if="openAllComp">unfold_less</v-icon>
                        <v-icon v-else>unfold_more</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="openAllComp">Tancar Sessions</span>
                    <span v-else>Obrir Sessions</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text class="comparador--column-body">
                  <p class="text-center mt-2" v-if="boardComp.length === 0">
                    No hi ha objectius per mostrar
                  </p>
                  <v-treeview
                    v-model="selectedforPending"
                    :key="compKey"
                    :items="boardCompLocked"
                    item-disabled="locked"
                    :open="openAllCompArr"
                    item-text="title"
                    :search="searchBoth ? filterActivitat : ''"
                    selectable
                    open-on-click
                    class="pb-6"
                  >
                    <template v-slot:label="{ item }">
                      <span
                        class="d-flex justify-space-between"
                        :class="{
                          'green--text':
                            item.meta && isUsed(mapIdBoard, item.meta.id),
                        }"
                      >
                        {{ item.title }}
                        <v-chip v-if="item.children.length > 0" small>
                          {{ item.children.length }}
                        </v-chip>
                      </span>
                    </template>
                  </v-treeview>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    service: {
      type: Object,
      required: true,
    },
    planificacioTitle: {
      type: String,
      required: true,
    },
    board: {
      type: Array,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      filterActivitat: null,
      planificacions: [],
      boardComp: [],
      selectedforPending: [],
      searchBoth: false,
      openAllBoard: false,
      openAllComp: false,
      boardKey: 0,
      compKey: 0,
    }
  },
  methods: {
    close() {
      this.dialog = false
      this.$emit("loadKanban")
    },
    updateComp(selectComparativa) {
      if (selectComparativa !== null) {
        this.searchBoth = false
        this.service
          .getKanbanColumns(selectComparativa.value)
          .then(response => {
            this.boardComp = response.data.board
          })
          .catch(error => {
            this.$notify({
              type: "error",
              title: this.$store.state.commonText.notification.errorTitle,
              text:
                this.$store.state.commonText.notification.errorText +
                "<br>" +
                error,
            })
          })
      }
    },
    isUsed(arrToComp, id) {
      return arrToComp.includes(id)
    },
    searchItem(term) {
      this.filterActivitat = term
      this.searchBoth = true
    },
    copyObjectius() {
      if (this.selectedforPendingIds.length) {
        const id = this.$route.params["id"]
        this.service
          .copyItemsToPending(id, this.selectedforPendingIds)
          .then(response => {
            if (response.status === 200) {
              this.$emit("loadKanban")
            }
          })
          .catch(error => {
            this.$notifyErrorByStatusCode(error.response.status)
          })
      }
      this.selectedforPending = []
    },
  },
  beforeMount() {
    const id = this.$route.params["id"]
    this.service.getListComparadorItems(id).then(response => {
      this.planificacions = response.data
    })
  },
  computed: {
    openAllBoardArr() {
      return this.openAllBoard ? this.board.map(objectiu => objectiu.id) : []
    },
    openAllCompArr() {
      return this.openAllComp ? this.boardComp.map(objectiu => objectiu.id) : []
    },
    mapIdComp() {
      return this.boardComp
        ? this.boardComp
            .map(column =>
              column.children.map(item => {
                return [
                  item.meta.id,
                  ...item.children.map(subitem => subitem.meta.id),
                ]
              })
            )
            .flat(2)
        : []
    },
    mapIdBoard() {
      return this.board
        ? this.board
            .map(column =>
              column.children.map(item => {
                return [
                  item.meta.id,
                  ...item.children.map(subitem => subitem.meta.id),
                ]
              })
            )
            .flat(2)
        : []
    },
    selectedforPendingIds() {
      let ids = []
      for (let i = 0; i < this.selectedforPending.length; i++) {
        const selectedId = this.selectedforPending[i]
        const id = this.boardComp
          .map(planificacio => planificacio.children)
          .flat()
          .filter(objectiu => objectiu.id === selectedId)
          .map(objectiu => objectiu.meta.id)[0]
        if (id !== undefined && ids.indexOf(id) === -1) {
          ids.push(id)
        }
      }
      return ids
    },
    boardCompLocked() {
      let newBoardComp = this.boardComp
      newBoardComp.forEach(mesocicle => {
        mesocicle.children.forEach(objectiu => {
          if (this.mapIdBoard.includes(objectiu.meta.id)) {
            objectiu.locked = true
          }
        })
      })
      return newBoardComp
    },
  },
}
</script>

<style lang="scss" scoped>
.rotate-icon {
  transform: rotate(180deg);
}
.comparador--column {
  position: relative;
  &-toolbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }
  &-body {
    position: absolute;
    bottom: 0;
    height: calc(100% - 64px);
    overflow-y: auto;
  }
}
</style>
